import React from 'react'
import {PaymentCheckoutQrisDetail} from '../containers'

export default function PaymentCheckoutQrisDetailScreen() {
  return <PaymentCheckoutQrisDetail />
}
